function isVisible(el) {
  if (!el) return false;
  if (el.offsetParent === null) return false;

  const style = window.getComputedStyle(el);
  if (style.visibility === 'hidden' || style.display === 'none') return false;

  const rect = el.getBoundingClientRect();
  if (rect.width === 0 && rect.height === 0) return false;

  return true;
}

function isFocusable(el) {
  if (el.disabled) return false;
  return (
    el.matches(
      'a[href], button, textarea, input, select, [tabindex]:not([tabindex="-1"])'
    ) && isVisible(el)
  );
}

export default {
  methods: {
    /** All visible focusable elements in document */
    getVisibleFocusable() {
      return Array.from(
        document.querySelectorAll(
          'a[href], button, textarea, input, select, [tabindex]'
        )
      ).filter(isFocusable);
    },

    /** Focusables inside popper ref */
    getFocusableInside(refName) {
      const root = this.$refs[refName];
      if (!root) return [];

      return Array.from(
        root.querySelectorAll(
          'a[href], button, textarea, input, select, [tabindex]'
        )
      ).filter(isFocusable);
    },

    /** Focusables outside the popper ref */
    getFocusableOutside(refName) {
      const inside = new Set(this.getFocusableInside(refName));
      return this.getVisibleFocusable().filter(el => !inside.has(el));
    },

    /** Move focus to next outside element */
    focusNextOutside(refName) {
      const outside = this.getFocusableOutside(refName);
      const active = document.activeElement;

      const i = outside.indexOf(active);
      const next = outside[i + 1] || outside[0];

      if (next) next.focus();
    },

    /** Move focus to previous outside element */
    focusPrevOutside(refName) {
      const outside = this.getFocusableOutside(refName);
      const active = document.activeElement;

      const i = outside.indexOf(active);
      const prev = outside[i - 1] || outside[outside.length - 1];
      if (prev) prev.focus();
    },
  }
}
